import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { XpButtonComponent, XpButtonVariant } from '../button/xp-button.component';

export type XpMenuValue = string | number;

export type XpMenuIconPosition = 'start' | 'end';

export interface XpMenuOption {
	label: string;
	value: XpMenuValue;
	icon?: string;
}

@Component({
	selector: 'xp-menu-select',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatMenuModule, MatTooltipModule, XpButtonComponent],
	templateUrl: './xp-menu-select.component.html',
	styleUrls: ['./xp-menu-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpMenuSelectComponent {
	label = input('');
	icon = input('');
	iconPosition = input<XpMenuIconPosition>('end');
	options = input<XpMenuOption[]>([]);
	variant = input<XpButtonVariant>('outline');
	disabled = input(false);
	disabledTooltip = input<string | null>(null);
	ariaLabel = input<string | null>(null);
	optionSelected = output<XpMenuValue>();
}
